





















import { POS_FILTER_TYPE, PosFilter } from 'gl-ms-positions';
import { ACTION_GET_VEHICLES, ACTION_SET_FILTER } from '@/store/modules/realtime';
import EventsBus, { EVENTS_TYPE } from '@/services/eventbus';

export default {
    data() {
        return {
            textModel: '',
            selectModel: [],
        };
    },
    props: ['filter', 'filterKey'],
    computed: {
        isSelect(this: any) {
            return this.currentFilter.type === POS_FILTER_TYPE.SELECT;
        },
        isText(this: any) {
            return this.currentFilter.type === POS_FILTER_TYPE.TEXT;
        },
        key(this: any) {
            return this.currentFilter.key;
        },
        currentFilter(this: any) {
            return this.$store.state.realtime.filters.find((item: PosFilter) => item.key === this.filterKey);
        },
        options(this: any) {
            if (this.isSelect) {
                return this.currentFilter.items;
            }

            return [];
        },
        placeholder(this: any) {
            if (this.selectModel && this.selectModel.length) {
                return '';
            }
            return this.$t(`filter.${this.key}`);
        },

        isDisabled(this: any) {
            return !this.currentFilter.enabled;
        },
    },
    watch: {
        currentFilter(this:any) {
            this.updateSelected();
        },
    },
    methods: {
        async update(this: any) {
            const values = this.isSelect ? this.selectModel : this.textModel;
            await this.$store.commit(ACTION_SET_FILTER, { key: this.key, values });
            await this.$store.dispatch(ACTION_GET_VEHICLES, true);
            this.$nextTick(() => {
                if (!this.centered) {
                    EventsBus.$emit(EVENTS_TYPE.REALTIME_MAP_CENTER);
                }
            });
        },
        updateSelected(this: any) {
            if (this.currentFilter) {
                if (this.isSelect) {
                    this.selectModel = this.currentFilter.selected;
                }

                if (this.isText) {
                    this.textModel = this.currentFilter.selected;
                }
            }
        },
    },

    mounted(this: any) {
        this.updateSelected();
    },
};
